export const enUS = {
  translation: {
    common: {
      loading: 'Loading...',
      error: 'Error',
      button: 'Go to Dashboard',
      goToDashboard: 'Go to Dashboard',
    },
    noPermission: {
      title: 'No Permission',
      description: 'You do not have permission to access this page.',
      goToDashboardDescription: 'You do not have permission to access this page. Please contact the administrator to get access.',
      goToDashboardButton: 'Go to Dashboard',
    },
    'Add Fulfillment': 'Add Fulfillment',
    'Input Your data': 'Input Your data',
    Name: 'Name',
    Select: 'Select',
    search: {
      placeholder: 'Search',
    },
    login: {
      title: 'Login via Xinchuan Auth',
      button: 'Login via ',
      success: 'Login successful',
      authCallback_success: 'Login authCallback successful',
      authCallback_authentication_failed: 'Login authCallback authentication failed: {error}',
      authCallback_invalid_parameters: 'Login authCallback invalid parameters',
      authCallback_invalid_state_parameter: 'Login authCallback invalid state parameter',
      authCallback_failed: 'Login authCallback failed',
      authCallback_completing_authentication: 'Login authCallback completing Authentication',
      authCallback_redirecting: 'Login authCallback redirecting'
    },
    sidebar: {
      overview: 'Overview',
      operational: 'Operational',
      dashboard: 'Dashboard',
      fulfillment: 'Manage Fulfillment',
      addFulfillment: 'Add Fulfillment',
      aggregator: 'Manage Aggregator',
      wallet: 'Wallet Balance',
      report: 'Report Center',
      products: 'Products',
      logout: 'Logout',
      product_group: 'Product Group',
      product_management: 'Product Management',
      manage_sku: 'Manage SKU',
      product_fee: 'Product Fee',
      voucherpin: 'Voucher PIN',
      voucher_pin_import: 'Import Voucher PIN',
      voucher_pin: 'Voucher PIN',
      orders: 'Orders',
      manage_orders: 'Manage Orders',
    },

    pages: {
      wallet: 'Manage Wallet Balance',
      report: 'Report Center',
      product_group: 'Product Group',
      product_management: 'Product Management',
      manage_sku: 'Manage SKU',
      voucher_pin: 'Voucher PIN',
      orders: 'Manage Orders',
    },
    orders: {
      title: 'Manage Orders',
      searchPlaceholder: 'Invoice, customer ID, or payment ID',
      empty: 'No orders',
      columns: {
        identifier: 'Invoice Number',
        createdAt: 'Date',
        status: 'Status',
        paymentMethod: 'Payment Method',
        paymentId: 'Payment ID',
        customer: 'Customer',
        quantity: 'Qty',
        purchase: 'Purchase',
        totalFee: 'Total Fee',
        paymentFee: 'Payment Fee',
        amount: 'Amount Paid',
        expiresAt: 'Expires',
      },
      filters: {
        identifierPlaceholder: 'Exact invoice number',
        customerPlaceholder: 'Customer user ID',
        paymentPlaceholder: 'Payment ID',
        paymentMethodPlaceholder: 'Payment method ID',
        amountFrom: 'Min amount',
        amountTo: 'Max amount',
      },
      statuses: {
        waiting_for_payment: 'Waiting for payment',
        paid: 'Paid',
        processing: 'Processing',
        pending: 'Pending',
        complete: 'Complete',
        cancelled: 'Cancelled',
        expired: 'Expired',
      },
      lineStatuses: {
        pending: 'Pending',
        fulfilling: 'Fulfilling',
        fulfilled: 'Fulfilled',
        failed: 'Failed',
      },
      paymentCreation: {
        not_started: 'Not started',
        creating: 'Creating',
        created: 'Created',
        unknown: 'Unknown',
      },
      feeTypes: {
        product_fee: 'Product fee',
        payment_fee: 'Payment fee',
      },
      fulfillmentErrors: {
        delivery_failed: 'Delivery failed',
        destination_invalid: 'Destination invalid',
        reconciliation_required: 'Reconciliation required',
      },
      overview: {
        title: 'Order Details',
        refresh: 'Refresh',
        information: 'Information',
        customer: 'Customer Details',
        payment: 'Payment Information',
        amounts: 'Amounts',
        lines: 'Items',
        breakdown: 'Order Breakdown',
        fees: 'Fees',
        timeline: 'Status History',
        identifier: 'Invoice Number',
        copy: 'Copy invoice number',
        copied: 'Invoice number copied',
        paymentMethodId: 'Payment Method',
        paymentId: 'Payment ID',
        paymentCreation: 'Payment Creation',
        expiresAt: 'Expires At',
        currency: 'Currency',
        customerId: 'Customer ID',
        noCustomer: 'No customer ID',
        purchase: 'Purchase',
        totalFee: 'Total Fee',
        paymentFee: 'Payment Fee',
        amount: 'Amount to Be Paid',
        product: 'Product',
        destination: 'Destination',
        quantity: 'Qty',
        unitPrice: 'Unit Price',
        fulfillment: 'Fulfillment',
        reviewRequired: 'Review required',
        feeType: 'Type',
        feeName: 'Name',
        feeAmount: 'Amount',
        refundable: 'Refundable',
        yes: 'Yes',
        no: 'No',
        noLines: 'No items',
        noFees: 'No fees',
        noTimeline: 'No status history',
        paymentUrl: 'Payment URL',
        instructions: 'Payment Instructions',
        notes: 'Notes',
        addNote: 'Add note',
        attach: 'Attach file',
        removeAttachment: 'Remove attachment',
        notePlaceholder: 'Internal note',
        noteAdded: 'Note added',
        noNotes: 'No notes',
        loadingNotes: 'Loading notes',
        moreNotes: 'Older notes',
        attachments: 'Attachments',
        attachHint: 'Attach files by dragging, pasting, or clicking here.',
        fulfillmentDestination: 'Fulfillment Destination',
        fulfillmentError: 'Fulfillment Error',
      },
      rowActions: {
        expandRow: 'Expand order',
        collapseRow: 'Collapse order',
      },
    },
    voucherPin: {
      title: 'Manage Voucher PIN Codes',
      searchPlaceholder: 'Search PIN prefix',
      empty: 'No PINs',
      emptyNoFilter: 'Select a SKU, status, or search to view voucher PIN codes',
      selectSku: 'Select SKU',
      selectStatus: 'Status',
      register: 'Register New Vouchers',
      upload: 'Upload Vouchers',
      uploadHistory: 'View Upload History',
      filterByProduct: 'Filter Voucher PIN by Product',
      selectProvider: 'Select provider',
      selectProduct: 'Select product',
      codesTitle: 'Voucher PIN Codes',
      sold: 'Sold',
      edit: 'Edit',
      detail: {
        title: 'Product Details',
        view: 'View product details',
        productInfo: 'Product Information',
        stockInfo: 'Stock Settings',
        skuId: 'SKU ID',
        code: 'Code',
        name: 'Name',
        pinFormat: 'PIN Format',
        legacyProducts: 'Legacy Products',
        lowStock: 'Low Stock Threshold',
        restockDelay: 'Restock Delay',
        disabled: 'Disabled',
        recallable: 'Recallable',
        yes: 'Yes',
        no: 'No',
        copy: 'Copy',
        unavailable: 'Not Available',
        expandRow: 'Expand row',
        collapseRow: 'Collapse row',
      },
      columns: {
        code: 'Code',
        sku: 'SKU',
        batch: 'Batch',
        status: 'Status',
        cost: 'Cost',
        costMin: 'Min',
        costMax: 'Max',
        createdBy: 'Created by',
        createdAt: 'Created',
        action: 'Action',
        copied: 'Copied',
        revealing: 'Loading code...',
      },
      status: {
        available: 'Available',
        reserved: 'Reserved',
        allocated: 'Allocated',
        voided: 'Voided',
      },
      form: {
        registerTitle: 'Register New Vouchers',
        uploadTitle: 'Upload Vouchers',
        editTitle: 'Edit Voucher PIN Codes',
        product: 'Product',
        provider: 'Provider',
        pinCode: 'Voucher PIN Code',
        pinPlaceholder: 'Input voucher PIN Code',
        histories: 'Histories',
        noSubmissions: 'You have not submitted any voucher PIN code',
        submittedCount: 'Submitted {{count}} PIN codes',
        registerNotice:
          'Make sure that the voucher code you input is for <b>{{product}}</b> from <b>{{provider}}</b>',
        uploadNotice:
          'Make sure that the file you select is for <b>{{product}}</b> from <b>{{provider}}</b>',
        price: 'Price: <b>{{price}}</b>',
        file: 'File',
        costPrice: 'Cost Price',
        costInvalid: 'Cost price cannot exceed the product price ({{price}})',
        template: 'Template',
        templateHint: 'You can download the template <link>here</link>',
        currentPin: 'Current PIN',
        newPin: 'New Voucher PIN Codes',
        confirmTitle: 'Are you sure?',
        confirmIntro: 'You are about to change the PIN',
        from: 'from:',
        to: 'to:',
        paste: 'Paste image',
      },
    },
    Button: {
      Info: 'Info',
      Success: 'Success',
      Error: 'Error',
      Warning: 'Warning',
      Confirm: 'Confirm',
    },
    fileUpload: {
      uploading: 'Uploading',
      attach_files: 'Attach files by Drag & Drop, Paste or Click Here',
      errors: {
        file_too_large: 'File size is too large. Maximum file size is {size}MB.',
        max_files: 'Maximum {max} files allowed. You have {remaining} remaining slots.',
        invalid_content: 'Invalid file content. Please upload a valid image (JPEG, PNG, or SVG).',
        upload_failed: 'Upload failed. Please try again.',
      },
      success: 'File uploaded successfully.',
      errors_upload_failed: 'Upload failed. Please try again.',
    },
    imageUpload: {
      uploading: 'Uploading',
      attach_files: 'Attach files by Drag & Drop, Paste or Click Here',
      addPhoto: 'Add Photo',
      main: 'Main',
      setAsMain: 'Set as main',
      success: 'Image uploaded successfully.',
      errors: {
        file_too_large: 'File size is too large. Maximum file size is {size}MB.',
        max_files: 'Maximum {max} files allowed. You have {remaining} remaining slots.',
        invalid_content: 'Invalid file content. Please upload a valid image (JPEG, PNG, or SVG).',
        upload_failed: 'Upload failed. Please try again.',
        not_image: 'Please select an image file.',
      },
    },
    pagination: {
      prev: 'Prev',
      next: 'Next',
      prevPageAria: 'Previous page',
      nextPageAria: 'Next page',
    },
    table: {
      filterReset: 'Reset',
    },
    ui: {
      cancel: 'Cancel',
      imageCrop: {
        title: 'Upload Image',
        save: 'Save',
        invalid: 'Please upload a JPG or PNG image up to {{max}} MB.',

      },
      emptyState: {
        noData: 'No data',
      },
      chart: {
        noData: 'No chart data available.',
      },
      dateTimeRangeFilter: {
        startDate: 'Start date',
        endDate: 'End date',
      },
      numberRangeFilter: {
        reset: 'Reset',
        search: 'Search',
      },
      statusBadge: {
        available: 'Available',
        unavailable: 'Unavailable',
        hidden: 'Hidden',
        disabled: 'Disabled',
        success: 'Success',
        pending: 'Pending',
        failed: 'Failed',
        refunded: 'Refunded',
        uncertain: 'Uncertain',
        processing: 'Processing',
      },
    },

    report: {
      selectSection: 'Select a report type from the menu',
      category: 'Report Category',
      fulfillment: {
        item: 'Fulfillment',
        title: 'Item Fulfillment',
        description: 'Generate an item procurement report for the selected period',
        supplier: 'Supplier',
        supplierPlaceholder: 'Select supplier',
        period: 'Period',
        export: 'Export',
      },
    },
    fulfillment: {
      empty: 'No fulfillments match your filters.',

      columns: {
        transactionId: 'Transaction ID',
        invoiceNumber: 'Invoice Number',
        foreignOrderId: 'Foreign Order ID',
        status: 'Status',
        supplier: 'Supplier',
        product: 'Product',
        cost: 'Cost',
        walletBalance: 'Wallet Balance',
        createdAt: 'Created At',
        fulfilledAt: 'Fulfilled At',
        errorMessage: 'Error Message',
      },
      filters: {
        transactionIdPlaceholder: 'Transaction ID',
        invoiceNumberPlaceholder: 'Invoice Number',
        foreignOrderRefsPlaceholder: 'Enter refs (Enter to add)',
      },
      suppliers: {
        alterra: 'Alterra',
        billfazz: 'Billfazz',
      },
      rowActions: {
        expandRow: 'Expand row',
        collapseRow: 'Collapse row',
      },
      overview: {
        generalInfo: 'General Information',
        orderDetail: 'Order Detail',
        notes: 'Notes',
        destination: 'Destination',
        errorMessage: 'Error Message',
        noErrorMessage: 'No error message',
        errorCode: 'Error Code',
        vendorErrorCode: 'Vendor Error Code',
        vendorErrorMessage: 'Vendor Error Message',
      },
    },
    aggregator: {
      empty: 'No aggregator products match your filters.',
      columns: {
        product: 'Product',
        sku: 'SKU Code',
        type: 'Type',
        status: 'Status',
        actions: 'Actions',
        errorMessage: 'Error Message',
        vendorCost: 'Procurement Cost',
      },
      type: {
        prepaid: 'Prepaid',
        postpaid: 'Postpaid',
      },
      filters: {
        productPlaceholder: 'Product',
        idPlaceholder: 'SKU Code',
        available: 'Available',
        unavailable: 'Unavailable',
      },
      status: {
        available: 'Available',
        unavailable: 'Unavailable',
      },
      rowActions: {
        action: 'Action',
        edit: 'Edit',
        enable: 'Enable',
        disable: 'Disable',
        expandRow: 'Expand row',
        collapseRow: 'Collapse row',
      },
      statusModal: {
        disableTitle: 'Disable Product?',
        enableTitle: 'Enable Product?',
        disableConfirm: 'Disable',
        enableConfirm: 'Enable',
        cancel: 'Cancel',
        warningTitle: 'Warning',
        disableImpact:
          'By disabling this product, customers will no longer be able to purchase it until it is enabled again.',
        disableSuccess: 'Product disabled successfully',
        enableSuccess: 'Product enabled successfully',
        disablePrompt: 'Are you sure you want to disable',
        enablePrompt: 'Are you sure you want to enable',
        disableNote: 'The product will remain disabled until it is manually enabled again.',
        enableNote: 'This action will make the product available for purchase again.',
      },
      overview: {
        generalInfo: 'General Information',
        aggregatorInfo: 'Aggregator Information',
        name: 'Name',
        vendor: 'Vendor',
        vendorSku: 'SKU',
        priority: 'Priority',
        procurementCost: 'Procurement Cost',
      },
      editModal: {
        title: 'Edit Product',
        saveChanges: 'Save Changes',
        productInfo: 'Product Information',
        productName: 'Product Name',
        aggregatorMappings: 'Aggregator Mappings',
        aggregatorColumn: 'Aggregator',
        updateSuccess: 'Product updated successfully',
      },
    },
    productGroup: {
      empty: 'No product groups match your filters.',
      columns: {
        product: 'Product',
        price: 'Price',
        actions: 'Action',
      },
      actions: {
        import: 'Import',
        export: 'Export',
        newGroup: 'New Group',
      },
      rowActions: {
        action: 'Action',
        edit: 'Edit',
        editProduct: 'Edit Product',
        addChild: 'Add Child',
        addPlanGroup: 'Add Plan Group',
        attachProduct: 'Attach Product',
        changeOrder: 'Change Order',
        detachProduct: 'Detach Product',
        enable: 'Enable',
        disable: 'Disable',
        delete: 'Delete',
        expandRow: 'Expand row',
        collapseRow: 'Collapse row',
      },
      modals: {
        createTitle: 'Add New Group',
        editGroupTitle: 'Edit Group',
        changeOrderTitle: 'Change Order',
        changeOrderEmpty: 'No products in this group',
        saveChanges: 'Save Changes',
        reorder: 'Drag to reorder',
        orderSaved: 'Order saved',
        editProductTitle: 'Edit Product',
        attachTitle: 'Attach Product',
        deleteTitle: 'Delete Group',
        deleteProductTitle: 'Delete Product',
        detachTitle: 'Detach product',
        deletePrompt: 'Are you sure you want to delete "<bold>{{name}}</bold>"?',
        deleteProductPrompt: 'Are you sure to delete this "<bold>{{name}}</bold>"?',
        deleteConfirm: 'Delete',
        deleteNote: 'You can’t undo this action.',
        deleteImpact: 'By deleting this group, related records may lose their group reference and some actions may no longer be available.',
        detachPrompt: 'Are you sure to detach "<bold>{{name}}</bold>"?',
        groupInformation: 'Group Information',
        name: 'Name',
        namePlaceholder: 'Enter Name',
        nameRequired: 'Name is required',
        photo: 'Photo',
        groupType: 'Group Type',
        section: 'Section',
        sectionPlaceholder: 'Select Section',
        sectionRequired: 'Section is required',
        parentGroup: 'Parent Group',
        parentPlaceholder: 'Select Parent Group',
        hidden: 'Hidden',
        upload: 'Upload',
        changeImage: 'Change image',
        removeImage: 'Remove image',
        imageHint: '*<bold>Image</bold> format only (max <bold>2MB</bold>)',
        imageTransparent:
          'The image Contain a <bold>transparent background</bold> so the green background remains visible.',
        imageTypeError: 'Image must be JPG, PNG, or JPEG.',
        imageSizeError: 'Image must be 2 MB or smaller.',
        types: {
          subgroup: 'Subgroup',
          product: 'Product',
          esimCountry: 'ESIM Country',
        },
        sections: {
          dataPerDay: 'Data per Day',
          dataInTotal: 'Data in Total',
        },
        save: 'Save Changes',
        createGroup: 'Create Group',
        cancel: 'Cancel',
        yes: 'Yes',
        no: 'No',
        attach: 'Attach Product',
        product: 'Product',
        products: 'Products',
        selectProduct: 'Select Product',
        noProducts: 'No products match your search.',
        loadingProducts: 'Loading products…',
        attachLoadError: 'Failed to load products',
        productName: 'Product Name',
        price: 'Price',
        availability: 'Availability',
        available: 'Available',
        notAvailable: 'Not Available',
        productStatus: 'Product Status',
        enabled: 'Enabled',
        disabled: 'Disabled',
        visibility: 'Visibility',
        visible: 'Visible',
        refundable: 'Refundable',
        productDisabled: 'Product disabled',
        availableHint: 'Item can be purchased',
        notAvailableHint: 'Item cannot be purchased',
        visibleHint: 'Appears in listings',
        hiddenHint: 'Hidden from listings',
        enabledHint: 'Item is active and functional',
        disabledHint: 'Item is inactive',
        refund: 'Refund',
        nonRefundable: 'Non-refundable',
        refundableHint: 'Item is eligible for a refund',
        nonRefundableHint: 'Item is not eligible for a refund',
        locale: 'Locale',
        description: 'Description',
        descriptionPlaceholder: 'Input description',
        rootParent: 'None (root)',
        created: 'Group created',
        updated: 'Group updated',
        productUpdated: 'Product updated',
        deleted: 'Deleted "{{name}}"',
        productDeleted: 'Deleted "{{name}}"',
        detached: 'Detached "{{name}}"',
        attached: 'Product attached',
      },
      statusModal: {
        disableTitle: 'Disable Product?',
        enableTitle: 'Enable Product?',
        disableConfirm: 'Disable',
        enableConfirm: 'Enable',
        cancel: 'Cancel',
        warningTitle: 'Warning',
        disableImpact:
          'By disabling this product, customers will no longer be able to purchase it until it is enabled again.',
        disableSuccess: 'Product disabled successfully',
        enableSuccess: 'Product enabled successfully',
        disablePrompt: 'Are you sure you want to disable',
        enablePrompt: 'Are you sure you want to enable',
        disableNote: 'The product will remain disabled until it is manually enabled again.',
        enableNote: 'This action will make the product available for purchase again.',
      },
    },
    productManagement: {
      empty: 'No products match your filters.',
      columns: {
        product: 'Product Name',
        priceScheme: 'Price Scheme',
        schemes: {
          fixed: 'Fixed',
          per_account: 'Per Account',
          user_defined: 'User Defined',
        },
        price: 'Price',
        type: 'Type',
        types: {
          unit: 'Unit',
          bundle: 'Bundle',
        },
        description: 'Description',
        status: 'Status',
        actions: 'Action',
      },
      status: {
        available: 'Available',
        unavailable: 'Unavailable',
        hidden: 'Hidden',
        disabled: 'Disabled',
      },
      actions: {
        import: 'Import',
        export: 'Export',
        changeOrder: 'Change Order',
      },
      export: {
        title: 'Export',
        provider: 'Provider',
        allProviders: 'All Provider',
        medium: 'Medium',
        allMediums: 'All Medium',
        electronic: 'Electronic',
        voucherPin: 'Voucher PIN',
        supplier: 'Supplier',
        allSuppliers: 'All Supplier',
        cancel: 'Cancel',
        export: 'Export',
        exported: 'Products exported',
        failed: 'Export failed',
        stillProcessing: 'Export is still processing',
        unitHint: 'The file includes unit products only.',
      },
      changeOrder: {
        title: 'Change Order',
        provider: 'Provider',
        selectProvider: 'Select Provider',
        cancel: 'Cancel',
        saveChanges: 'Save Changes',
        saved: 'Product order for {{provider}} saved',
      },
      import: {
        title: 'Import File',
        uploadData: 'Upload Data',
        downloadTemplate: 'Download <template>template</template> to view the sample of required format.',
        dropHint: 'Click or drag file to this area to upload',
        singleFile: 'You may upload a single file.',
        formats: 'Supported file formats: XLSX, XLS, and CSV.',
        cancel: 'Cancel',
        upload: 'Upload',
        data: 'Data',
        status: 'Status',
        errorDetails: 'Error Details',
        valid: 'Valid',
        invalid: 'Invalid',
        missingColumn: 'Missing column',
        successNote: 'Only success row(s) will be uploaded',
        invalidType: 'Please upload an XLSX file.',
        imported: 'Products imported',
        started: 'Import started',
        failed: 'Import failed',
        skipped: '{{count}} rows were skipped',
        stillProcessing: 'Import is still processing',
        row: 'Row',
        field: 'Field',
        message: 'Message',
        summary: 'Wrote {{written}} products. Skipped {{skipped}}.',
        logNote: 'Review the rows the import did not write.',
        noneValid: 'No valid columns to import',
        columns: {
          id: 'ID',
          name: 'Name',
          fapiao_name: 'Fapiao Name',
          medium: 'Medium',
          price: 'Price',
          reference_cost_price: 'Cost Price',
          price_scheme: 'Price Scheme',
          supplier_product_code: 'Supplier Product Code',
          denomination_currency: 'Denomination Currency',
          denomination: 'Denomination',
          type: 'Type',
        },
      },
      rowActions: {
        action: 'Action',
        setInstruction: 'Set Instruction',
        edit: 'Edit',
        enable: 'Enable',
        disable: 'Disable',
      },
      instruction: {
        title: 'Set Instruction',
        locale: 'Locale',
        instruction: 'Instruction',
        placeholder: 'Enter Instruction',
        add: 'Add Instruction',
        remove: 'Remove instruction',
        cancel: 'Cancel',
        saveChanges: 'Save Changes',
        saved: 'Instruction saved',
      },
      edit: {
        photoLabel: 'Photo',
        title: 'Edit Product',
        cancel: 'Cancel',
        back: 'Back',
        next: 'Next',
        saveChanges: 'Save Changes',
        saved: 'Product updated',
        photo: 'Photo',
        uploadTitle: 'Upload Image',
        uploadSave: 'Save',
        name: 'Name',
        description: 'Description',
        descriptionPlaceholder: 'Enter description',
        locale: 'Locale',
        imageHint: '*<bold>Image</bold> format only (max <bold>2MB</bold>)',
        imageTransparent: 'The image Contain a <bold>transparent background</bold> so the green background remains visible.',
        steps: {
          info: 'Product Info',
          details: 'Product Details',
          visibility: 'Visibility & Access',
        },
        pricing: 'Pricing',
        priceScheme: 'Price Scheme',
        priceCurrency: 'Price Currency',
        price: 'Price',
        priceBundleHint: 'This price follows the bundle. Change it in the bundle price.',
        referenceCostCurrency: 'Reference Cost Currency',
        referenceCostPrice: 'Reference Cost Price',
        denominationCurrency: 'Denomination Currency',
        denomination: 'Denomination',
        productDetails: 'Product Details',
        medium: 'Medium',
        type: 'Type',
        supplierProductCode: 'Supplier Product Code',
        productBundle: 'Product Bundle',
        bundleSearch: 'E.g. IF or IF 50 NT',
        bundleCount: '{{count}} item(s)',
        total: 'Total',
        availability: 'Availability',
        available: 'Available',
        availableHint: 'Item can be purchased',
        notAvailable: 'Not Available',
        notAvailableHint: 'Item cannot be purchased',
        productStatus: 'Product Status',
        enabled: 'Enabled',
        enabledHint: 'Item is active and functional',
        disabled: 'Disabled',
        disabledHint: 'Item is inactive',
        visibility: 'Visibility',
        visible: 'Visible',
        visibleHint: 'Appears in listings',
        hidden: 'Hidden',
        hiddenHint: 'Hidden from listings',
        access: 'Access',
        publicAccess: 'Public Access',
        publicAccessHint: 'Visible to all users',
        restrictedAccess: 'Restricted Access',
        restrictedAccessHint: 'Visible to limited users',
        refundable: 'Refundable',
        schemes: {
          fixed: 'Fixed',
          per_account: 'Per Account',
          user_defined: 'User Defined',
        },
        mediums: {
          voucher_pin: 'Voucher PIN',
          electronic: 'Electronic',
        },
        types: {
          unit: 'Unit',
          bundle: 'Bundle',
        },
        bundleColumns: {
          product: 'Product',
          qty: 'Qty',
          price: 'Price',
          subtotal: 'Subtotal',
          action: 'Action',
        },
      },
    },
    productFee: {
      description: 'Match a product medium, a supplier, or both. Percentage fees can be included when the payment fee is calculated.',
      summary: '{{count}} rules',
      empty: 'No product fee rules',
      anyMedium: 'Any medium',
      anySupplier: 'Any supplier',
      yes: 'Yes',
      no: 'No',
      actions: {
        create: 'Create fee rule',
        edit: 'Edit',
        save: 'Save',
        delete: 'Delete',
      },
      columns: {
        name: 'Name',
        currency: 'Currency',
        products: 'Products',
        fee: 'Fee',
        paymentBasis: 'Payment fee basis',
        refundable: 'Refundable',
        status: 'Status',
        action: 'Action',
      },
      status: {
        enabled: 'Enabled',
        disabled: 'Disabled',
      },
      medium: {
        voucher_pin: 'Voucher PIN',
        electronic: 'Electronic',
        esim: 'eSIM',
        simcard: 'Physical Travel SIM',
      },
      scheme: {
        fixed: 'Fixed',
        percentage: 'Percentage',
      },
      form: {
        createTitle: 'Create product fee rule',
        editTitle: 'Edit {{name}}',
        name: 'Name',
        fapiao: 'Fapiao name',
        scheme: 'Fee scheme',
        currency: 'Currency',
        products: 'Product IDs',
        fee: 'Fee',
        percentageMax: 'A percentage fee cannot be more than 100.',
        paymentBasis: 'Include in payment fee basis',
        paymentBasisHint: 'On : This fee is included in the payment percentage.\nOff : Calculated from the product price only.\nFixed fees cannot be included.',
        refundable: 'Refundable',
        refundableHint: 'This fee can be returned.',
        enabled: 'Enabled',
        enabledHint: 'This rule is active.',
        localizedNames: 'Localized names',
        localizedPlaceholder: 'Name in this language',
        matchRequired: 'Choose a medium or a supplier. A rule needs at least one.',
        savedCreate: 'Product fee rule created',
        savedUpdate: 'Product fee rule updated',
        deleteTitle: 'Delete this fee rule?',
        deleteBody: 'Delete {{name}}? Products will stop using this fee.',
        deleted: 'Product fee rule deleted',
      },
    },
    manageSku: {
      searchPlaceholder: 'Search by SKU code or name',
      empty: 'No SKUs',
      yes: 'Yes',
      no: 'No',
      actions: {
        create: 'Create SKU',
      },
      filters: {
        status: 'Status',
        enabled: 'Enabled',
        disabledOnly: 'Disabled',
        recallable: 'Recallable',
        recallableYes: 'Recallable',
        recallableNo: 'Not recallable',
        legacyProductId: 'Legacy product ID',
      },
      columns: {
        code: 'SKU code',
        name: 'Name',
        identifier: 'Identifier',
        pinFormat: 'PIN format',
        lowStock: 'Low stock',
        recallable: 'Recallable',
        status: 'Status',
        legacyProducts: 'Legacy products',
        action: 'Action',
      },
      status: {
        enabled: 'Enabled',
        disabled: 'Disabled',
      },
      overview: {
        generalInfo: 'General Information',
        createdAt: 'Created at',
        updatedAt: 'Updated at',
      },
      rowActions: {
        action: 'Action',
        edit: 'Edit',
        expandRow: 'Expand row',
        collapseRow: 'Collapse row',
      },
      form: {
        createTitle: 'Create SKU',
        editTitle: 'Edit SKU',
        code: 'SKU code',
        name: 'Name',
        pinFormat: 'PIN format',
        pinFormatHint: 'Case-insensitive RE2 pattern. Leave empty for no format check.',
        lowStock: 'Low stock threshold',
        restockDelay: 'Restock delay (Days)',
        legacyProducts: 'Legacy product IDs',
        legacyProductsHint: 'Laravel product IDs. Saving replaces the full list.',
        disabled: 'Disabled',
        recallable: 'Recallable',
        codeRequired: 'SKU code is required',
        nameRequired: 'Name is required',
        invalidLegacyId: 'Enter positive numeric product IDs',
        create: 'Create',
        save: 'Save',
        created: 'SKU created',
        updated: 'SKU updated',
        notFound: 'SKU was not found',
        saveFailed: 'Could not save the SKU',
      },
    },
    wallet: {
      average_spending_per_day: 'Average Spending per Day',
      history: 'Wallet History',
      chart_balance: 'Balance',
      chart_change: 'Change',
      columns: {
        provider: 'Provider',
      },
    },
    voucherPinImport: {
      title: 'Import Voucher PIN',
      search: 'Search SKU code or name',
      skuId: 'SKU ID',
      status: 'Status',
      template: 'Download template',
      uploadButton: 'Upload file',
      empty: 'No import batches',
      ownBatches: 'Only batches you created are listed.',
      columns: {
        batch: 'Batch',
        sku: 'SKU',
        file: 'File',
        source: 'Source',
        status: 'Status',
        cost: 'Cost',
        rows: 'Processed',
        errors: 'Errors',
        accepted: 'Accepted',
        createdAt: 'Created',
        action: 'Action',
      },
      statuses: {
        uploaded: 'Uploaded',
        ready: 'Ready',
        preflight_failed: 'Preflight failed',
        committed: 'Committed',
        failed: 'Failed',
        cancelled: 'Cancelled',
        expired: 'Expired',
      },
      actions: { view: 'View', commit: 'Commit', cancel: 'Cancel' },
      rowActions: { expandRow: 'Expand row', collapseRow: 'Collapse row' },
      overview: { generalInfo: 'General Information' },
      confirm: {
        commitTitle: 'Commit this batch?',
        commitBody: 'Ready PIN codes will be written to stock.',
        cancelTitle: 'Cancel this batch?',
        cancelBody: 'This batch will not be imported.',
        yes: 'Yes',
        no: 'No',
      },
      upload: {
        title: 'Upload PIN file',
        hint: 'The file must be .xlsx or .csv with a pin_code header. Download the template if you do not have one.',
        skuId: 'SKU ID',
        drop: 'Drop an .xlsx or .csv file here',
        costPrice: 'Cost price',
        currency: 'Currency',
        autoCommit: 'Commit automatically when preflight passes',
        cancel: 'Cancel',
        submit: 'Upload',
        skuRequired: 'Enter an existing SKU id.',
        fileRequired: 'Choose an .xlsx or .csv file.',
        costInvalid: 'Cost must be a decimal with up to 4 fraction digits, such as 142.5000.',
        currencyInvalid: 'Currency must be 3 letters, such as TWD.',
        failed: 'The file was not accepted.',
      },
      detail: {
        title: 'Import batch',
        close: 'Close',
        loading: 'Loading batch...',
        missing: 'This batch could not be loaded.',
        row: 'Row',
        stage: 'Stage',
        message: 'Message',
        noLogs: 'No logs yet.',
        logs: 'Logs',
      },
    },
  },
};
